// SEQ-180 phase 2, P22: the Project manager and Site manager fields, shared
// by NewProject and EditProjectModal so the two forms cannot drift in label,
// placeholder or suggestion behaviour.
//
// Free text with a datalist (D22). Optional, trimmed on save, no other
// validation. `idPrefix` keeps the input ids and the datalist ids unique if
// both forms are ever mounted at once.

import { useProjectPeopleOptions } from '../hooks/useProjectPeopleOptions';

interface ProjectPeopleFieldsProps {
  idPrefix: string;
  projectManager: string;
  siteManager: string;
  onProjectManagerChange: (value: string) => void;
  onSiteManagerChange: (value: string) => void;
  /** Skip the suggestions fetch while the form is closed. */
  enabled?: boolean;
}

export function ProjectPeopleFields({
  idPrefix,
  projectManager,
  siteManager,
  onProjectManagerChange,
  onSiteManagerChange,
  enabled = true,
}: ProjectPeopleFieldsProps) {
  const { projectManagers, siteManagers } = useProjectPeopleOptions(enabled);

  const pmListId = `${idPrefix}-project-manager-options`;
  const smListId = `${idPrefix}-site-manager-options`;

  return (
    <div
      style={{
        marginTop: 'var(--spacing-lg)',
        padding: 'var(--spacing-lg)',
        background: 'var(--bg-tertiary)',
        borderRadius: 'var(--border-radius-lg)',
      }}
    >
      <h4 style={{ marginBottom: 4 }}>Project people</h4>
      {/* Design re-audit, LOW: --text-muted on --bg-tertiary is 2.24:1, well
          under AA. --text-secondary on the same background is 6.65:1. */}
      <p style={{ margin: '0 0 var(--spacing-md) 0', fontSize: 12, color: 'var(--text-secondary)' }}>
        Optional. Used to group projects in P&amp;L analytics, so the same spelling each time keeps a
        person to one row.
      </p>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: 'var(--spacing-lg)',
        }}
      >
        <div className="form-group">
          <label htmlFor={`${idPrefix}-projectManager`} className="form-label">
            Project manager
          </label>
          <input
            id={`${idPrefix}-projectManager`}
            type="text"
            className="form-input"
            list={pmListId}
            autoComplete="off"
            placeholder="e.g. Tom Nguyen"
            value={projectManager}
            onChange={(e) => onProjectManagerChange(e.target.value)}
          />
          <datalist id={pmListId}>
            {projectManagers.map((name) => (
              <option key={name} value={name} />
            ))}
          </datalist>
        </div>

        <div className="form-group">
          <label htmlFor={`${idPrefix}-siteManager`} className="form-label">
            Site manager
          </label>
          <input
            id={`${idPrefix}-siteManager`}
            type="text"
            className="form-input"
            list={smListId}
            autoComplete="off"
            placeholder="e.g. Dave Ryan"
            value={siteManager}
            onChange={(e) => onSiteManagerChange(e.target.value)}
          />
          <datalist id={smListId}>
            {siteManagers.map((name) => (
              <option key={name} value={name} />
            ))}
          </datalist>
        </div>
      </div>
    </div>
  );
}
